import { supplierModules, userModules } from '@r';
const state = {
  supplierList: JSON.parse(sessionStorage.getItem('supplierList')) || [],
  operateUserOptions: JSON.parse(sessionStorage.getItem('operateUserList')) || [],
  pickerOptions: {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一个月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近三个月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        },
      },
    ]
  },
  timeZoneOptions: [
    {
      label: "北京时间",
      value: 0,
    },
    {
      label: "美国PST时间",
      value: 1,
    }
  ],
  returnStatusOptions: [
    {
      label: "全部",
      value: "",
    },
    {
      label: "退货中",
      value: 1,
    },
    {
      label: "退货成功",
      value: 2,
    },
  ]
}

const mutations = {
  setSupplierList(state, data) {
    sessionStorage.setItem('supplierList', JSON.stringify(data));
    state.supplierList = data;
  },
  setOperateUserList(state, data){
    sessionStorage.setItem('operateUserList', JSON.stringify(data));
    state.operateUserOptions = data;
  }
}

const actions = {
  getSupplierList({ commit, state }) {
    if(state.supplierList.length > 0){
      return;
    }
    supplierModules.list({}).then((res) => {
      commit('setSupplierList', res.ldata);
    });
  },
  getOperateUserList({ commit, state }){
    if(state.operateUserOptions.length > 0){
      return;
    }
    userModules.getAdminUsers({}).then((res) => {
      commit('setOperateUserList', res.ldata);
    });
  }
}

const getters = {
  allSupplierList (state) {
    return [
      {
        id: "",
        name: "全部"
      },
      ...state.supplierList
    ];
  },
  allOperateUserList (state) {
    return [
      {
        id: "",
        nickname: "全部"
      },
      ...state.operateUserOptions
    ]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
